import { render, staticRenderFns } from "./modalTrasladarCarpeta.vue?vue&type=template&id=4ec1615a&"
import script from "./modalTrasladarCarpeta.vue?vue&type=script&lang=js&"
export * from "./modalTrasladarCarpeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports